import nameOf from 'src/app/shared/form/nameOf.helper';
import { SurveyDialogTemplateEditData, SurveyTemplateSettings } from 'src/app/models/surveyTemplate.model';
import { SurveyTemplateField } from './survey-dialog.model';

export const SURVEY_TEMPLATE_FIELDS: ReadonlyArray<SurveyTemplateField> = [
  nameOf<SurveyTemplateSettings>(x => x.surveyTypeId),
  nameOf<SurveyTemplateSettings>(x => x.organizationLevelId),
  nameOf<SurveyTemplateSettings>(x => x.requestedById),
  nameOf<SurveyTemplateSettings>(x => x.surveyDescription),
  nameOf<SurveyTemplateSettings>(x => x.fileAttachmentIds),
  nameOf<SurveyTemplateSettings>(x => x.name),
  nameOf<SurveyTemplateSettings>(x => x.surveyCode),
  nameOf<SurveyTemplateSettings>(x => x.surveyPlannedStartDate),
  nameOf<SurveyTemplateSettings>(x => x.surveyPlannedEndDate)
];

export const SURVEY_TEMPLATE_DATE_FIELDS: ReadonlyArray<SurveyTemplateField> = [
  nameOf<SurveyTemplateSettings>(x => x.surveyPlannedStartDate),
  nameOf<SurveyTemplateSettings>(x => x.surveyPlannedEndDate)
];

export const EDIT_SURVEY_TEMPLATE_ID_KEY = nameOf<SurveyDialogTemplateEditData>(x => x.editSurveyTemplateId);
